import axiosServices from 'utils/axios';
import { InsideFifaBackOfficeEndpoints } from '../consts';
import { GenericTableResponseConfigDto } from './dto';

export const deleteConfiguration = async (configId: number): Promise<GenericTableResponseConfigDto> => {
    const res = await axiosServices.delete<GenericTableResponseConfigDto>(
        `${InsideFifaBackOfficeEndpoints.GenericTables.Configs}/${configId}`,
    );
    return res.data;
};
